import {
  initFooter,
  initLangAction,
  initLangCookie,
  initResponsivecMenu,
} from "./common";

var lang;
$(document).ready(function () {
  $(function () {
    initFooter();
    initLangUi();
    initLs();
  });
});

function initLangUi() {
  lang = initLangCookie();
  console.log("index: lang = " + lang);
  initLangAction();
}

function initLs() {
  initResponsivecMenu();
  document.addEventListener("DOMContentLoaded", () => {
    const sections = document.querySelectorAll("article");
    const navLinks = document.querySelectorAll(".left-menu a");
    console.log("links: " + navLinks[2]);
    console.log("artivles: " + sections.length);
    const content = document.querySelector(".content");
    window.addEventListener("scroll", () => {
      let current = "";

      sections.forEach((section) => {
        const sectionTop = section.offsetTop;
        // Add a small offset so the change happens slightly before reaching the top
        if (scrollY >= sectionTop - 60) {
          current = section.getAttribute("id");
        }
      });

      navLinks.forEach((link) => {
        link.classList.remove("selected");
        if (link.getAttribute("href").includes(current)) {
          link.classList.add("selected");
        }
      });
    });
  });
}
